import { message } from 'ant-design-vue'
function errorMsg(error, msg) {
  if (typeof error == 'string') {
    message.warning({ content: error })
  } else {
    message.warning({ content: msg ? msg : '请求失败' })
  }
}
export default errorMsg
